import React from 'react';
import { fetchConnector, FetchPNLAnalyticsPropsFromRedux } from '../dataFetcher';
import { PNLAnalyticsEndpoint, PNLFetchStatus } from '../../actions/pnlAnalytics';
import { PNLGoodiesNonCompletedResponses } from '../PaperPlaceHolder';
import { STANDARD_GRAPH_ELEMENT_HEIGHT } from '../../common/common';
import { P_ARA, P_CP, P_FEI, P_LST, productMap, ProductMeta } from '../../common/products';
import LineGraph, { LineGraphConfig } from '../../containers/LineGraph';
import { ExposuresDataResp } from '../fetchTypes';
import { exposuresNumFormatter } from '../../common/exposures';
import { numberFormat } from '../../containers/pivotHelper';

type Props = FetchPNLAnalyticsPropsFromRedux & {};

const productLines = [P_FEI, P_ARA, P_CP, P_LST];
let lineConfig: LineGraphConfig = {
    title: 'Corp Spreads By Structure',
    dataKey: 'spread',
    oyLabel: '',
    oxLabel: '',
    referenceLines: [{ y: 0, label: '', stroke: 'black' }],
    yAxis: {
        yLimit: ['dataMin', 'dataMax'],
        yAxisFormatter: (v) => numberFormat(v, 0, false, false),
    },
    yTooltipFormatter: exposuresNumFormatter,
    chartsSettings: productLines.map((productName) => {
        let productMeta: ProductMeta = productMap.get(productName)!;
        return {
            key: productName,
            title: productMeta.title,
            color: productMeta.backgroundColor,
            chartType: productMeta.chartType!,
            stackId: productMeta.stackId,
            fillOpacity: productMeta.fillOpacity,
            strokeDasharray: productMeta.strokeDasharray,
        };
    }),
};

const SpreadByStructureGraph = (props: Props) => {
    const exposureData = props.pnlAnalytics.exposures;

    if (exposureData.status !== PNLFetchStatus.COMPLETED) {
        return (
            <PNLGoodiesNonCompletedResponses
                endpoint={PNLAnalyticsEndpoint.Exposures}
                data={exposureData}
                minHeight={STANDARD_GRAPH_ELEMENT_HEIGHT}
            />
        );
    }

    let respData = exposureData.data! as ExposuresDataResp;

    return <LineGraph {...lineConfig} values={respData.spreads_by_structure} />;
};

export default fetchConnector(SpreadByStructureGraph);
